// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_or-8";
export var editMode = "_or-3";
export var headerRow = "_or-a";
export var headerTitle = "_or-b";
export var product = "_or-1";
export var productDetails = "_or-5";
export var productDivider = "_or-7";
export var productImage = "_or-2";
export var productInfo = "_or-4";
export var productTitle = "_or-6";
export var strikethrough = "_or-9";
export var upsellProductsCard = "_or-0";